import { AssetErrorMessage } from "../types";

export class AssetUploadError {
  messages: AssetErrorMessage[];
  constructor(messages: AssetErrorMessage[]) {
    this.messages = messages;
  }
}
